import { Grid, makeStyles, Typography } from '@material-ui/core';
import { Formik } from 'formik';
import i18n from 'i18n';
import React from 'react';
import Button from 'components/Button';
import GenericForm from 'skyone-lib/lib/GenericForm';
import styles from './styles';
import schema from './schema';

const useStyles = makeStyles(styles);

interface FormDeviceValidationBypassProps {
  onClose: () => void;
  onSubmit: (values) => void;
}

const FormDeviceValidationBypass = ({
  onClose,
  onSubmit,
}: FormDeviceValidationBypassProps) => {
  const classes = useStyles();
  return (
    <Grid container spacing={2}>
      <Grid item>
        <Typography style={{ fontSize: 12 }}>
          {i18n.t('ENABLE_DEVICE_VALIDATION_BYPASS_MODAL_CONTENT_KEY')}
        </Typography>
      </Grid>

      <Formik
        initialValues={{ bypass_reason: '' }}
        enableReinitialize
        onSubmit={onSubmit}
        validationSchema={schema}
      >
        {({ setFieldValue, errors, values, submitForm }) => (
          <Grid
            item
            container
            xs={12}
            spacing={2}
            className={classes.reasonField}
          >
            <GenericForm
              fields={values}
              screenFields={[
                {
                  gridXs: 12,
                  label: i18n.t('REASON_KEY'),
                  stateKey: 'bypass_reason',
                  isMultiline: true,
                },
              ]}
              setFieldValue={setFieldValue}
              errors={errors}
            />
            <Grid
              container
              justify="flex-end"
              className={classes.buttonsBypassActions}
            >
              <Button id="cancel-button" variant="outlined" onClick={onClose}>
                {i18n.t('CANCEL_KEY')}
              </Button>
              <Button id="submit-button" deleteButton onClick={submitForm}>
                {i18n.t('IGNORE_KEY')}
              </Button>
            </Grid>
          </Grid>
        )}
      </Formik>
    </Grid>
  );
};

export default FormDeviceValidationBypass;
